<button
  #button
  class="custom-control form-button"
  type="button"
  (click)="buttonToggle()"
  [ngClass]="{
    'custom-checkbox': type === 'checkbox',
    'custom-radio': type === 'radio'
  }"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel"
  [attr.aria-checked]="this.type === 'checkbox' ? selected : null"
  
  [attr.role]="this.type === 'checkbox' ? 'checkbox' : null"
  [shrdUtcTrackEvent]="{
    event: trackingEvent,
    category: trackingCategory,
    action: trackingAction,
    label: trackingLabel
  }"
>
  <span class="custom-control-input" [ngClass]="{ 'is-checked': selected, 'is-disabled': disabled }"></span>
  <span class="custom-control-label form-button-label">
    <ng-content></ng-content>
  </span>
</button>
